import { create } from "zustand";
import { produce } from "immer";

const defaultData = {
  activeCustomerId: null,
  cache: {},
  loading: false,
  refreshing: false,
  error: null,
};

export const useCustomerDetails = create((set) => ({
  data: defaultData,
  actions: {
    selectCustomer: (customerId) =>
      set((state) =>
        produce(state, (draft) => {
          const hasCachedDetails = Boolean(state.data.cache[customerId]?.details);

          draft.data.activeCustomerId = customerId;
          draft.data.loading = !hasCachedDetails;
          draft.data.refreshing = hasCachedDetails;
          draft.data.error = null;
        })
      ),
    setRequestState: (customerId) =>
      set((state) =>
        produce(state, (draft) => {
          if (state.data.activeCustomerId !== customerId) return;

          const hasCachedDetails = Boolean(state.data.cache[customerId]?.details);
          draft.data.loading = !hasCachedDetails;
          draft.data.refreshing = hasCachedDetails;
          draft.data.error = null;
        })
      ),
    setDetails: (customerId, details, updatedAt = new Date().toISOString()) =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.cache[customerId] = { details, updatedAt };

          if (state.data.activeCustomerId !== customerId) return;
          draft.data.loading = false;
          draft.data.refreshing = false;
          draft.data.error = null;
        })
      ),
    setError: (customerId, error) =>
      set((state) =>
        produce(state, (draft) => {
          if (state.data.activeCustomerId !== customerId) return;
          draft.data.loading = false;
          draft.data.refreshing = false;
          draft.data.error = error;
        })
      ),
    close: () =>
      set((state) =>
        produce(state, (draft) => {
          draft.data.activeCustomerId = null;
          draft.data.loading = false;
          draft.data.refreshing = false;
          draft.data.error = null;
        })
      ),
    clear: () =>
      set((state) =>
        produce(state, (draft) => {
          draft.data = defaultData;
        })
      ),
  },
}));

